// extracted by mini-css-extract-plugin
export default {"NotFound":"NotFound_NotFound__9ewfS","body":"NotFound_body__y0YgX","code":"NotFound_code__L3Qkq","message":"NotFound_message__QP9AV"};